import React, { Component } from "react";
import { compose } from "recompose";
import { withRouter } from "../../boot/hooks/useRouter";
import moment from "moment";

import { withFirebase } from "../../components/Firebase";

import swal from "sweetalert";
import EventUtils from "../../services/EventUtils";
import EventView from "./view";

import { EVENT_IMAGES, MOMENT_SPANISH_LANG } from "../../config/defaults";
import tabs from "./tabs.json";

moment.locale("es", MOMENT_SPANISH_LANG);

class Event extends Component {
  constructor(props) {
    super(props);
    const now = moment();

    this.state = {
      startDate: now,
      endDate: now,
      timestamp: 0,
      tabActive: null,
      isLoading: true,
      privacity: "none",
    };

    this.changeTab = this.changeTab.bind(this);
    this.setTabByUrl = this.setTabByUrl.bind(this);

    this.onUpdateDoc = this.onUpdateDoc.bind(this);
    this.getEventData = this.getEventData.bind(this);

    this.onChangeImage = this.onChangeImage.bind(this);
    this.onDeleteImage = this.onDeleteImage.bind(this);
    this.onCustomPlayer = this.onCustomPlayer.bind(this);

    this.mounted = true;

    this.listener = () => {};
  }

  componentDidMount() {
    this.getEventData();
    this.props.onRequestLoading(false);
  }
  componentWillUnmount() {
    this.mounted = false;
    this.listener();
  }
  getEventData() {
    const { eid, tab } = this.props.match.params;

    this.docRef = this.props.firebase.getDoc("events", eid);

    this.listener = this.props.firebase.getCollectionBySocket(
      "events",
      eid,
      (doc) => {
        if (doc.exists) {
          const data = doc.data();
          const isAdmin =
            this.props.currentUser.sa === this.props.currentUser.uid;
          const isOwner = this.props.currentUser.uid === data.owner;
          if (data.ACTIVE && (isAdmin || isOwner)) {
            data.isLoading = false;
            if (data.startDate !== undefined && data.endDate !== undefined) {
              data.startDate = moment(data.startDate);
              data.endDate = moment(data.endDate);
            }
            data.id = eid;

            const eventData = new EventUtils(data);
            const { privacity = "none" } = eventData;
            const status = eventData.getStatus();

            if (status < 3) {
              data.tabActive = 5;
            } else {
              this.setTabByUrl(tab);
            }

            this.setState({ ...data, privacity, eventData });
          } else {
            if (this.mounted) {
              swal({
                text: "Event doesn't exists",
                icon: "error",
              }).then((value) => {
                this.props.history.goBack();
              });
            }
          }
        } else {
          if (this.mounted) {
            swal({ text: "Event doesn't exists", icon: "error" }).then(
              (value) => {
                this.props.history.goBack();
              }
            );
          }
        }
      }
    );
  }
  onUpdateDoc(data, callback) {
    this.props.firebase.updateDoc(this.docRef, data).then(callback);
  }
  changeTab(event, index) {
    const { tabActive = 0 } = this.state;
    if (index !== tabActive) {
      this.setState({ tabActive: index });
    }
  }
  setTabByUrl(tab) {
    const newIndex = tabs[tab.toUpperCase()] || 0;
    this.changeTab({}, newIndex);
  }
  onChangeImage(type, extension, path) {
    const self = this;
    const newValue = { ["IMAGE_" + type]: extension };
    const d = new Date();
    const { eventData = null } = this.state;

    this.props.onRequestLoading(true);

    this.props.firebase
      .updateDoc(this.docRef, newValue)
      .then((obj) => {
        eventData["IMAGE_" + type] = extension;
        self.setState({ eventData, timestamp: d.getTime() }, () => {
          self.props.onRequestLoading(false);
        });
      })
      .catch((error) => {
        self.props.onRequestLoading(false);
        swal("Opps!", error.message, "error");
      });
  }
  onDeleteImage(type) {
    const self = this;
    const d = new Date();
    const { eventData = null } = this.state;

    this.props.firebase.deleteField(this.docRef, ["IMAGE_" + type]).then(() => {
      eventData["IMAGE_" + type] = EVENT_IMAGES[type];
      self.setState({ eventData, timestamp: d.getTime() });
    });
  }
  onCustomPlayer(data) {
    const self = this,
      d = new Date();

      const { eventData = null } = this.state;

    return new Promise((resolve, reject) => {
      self.props.firebase
        .updateDoc(self.docRef, data)
        .then(() => {
          for (var obj in data) {
            eventData[obj] = data[obj];
          }

          self.setState({ timestamp: d.getTime(), eventData }, () => {
            self.props.onRequestLoading(false);
            resolve();
          });
        })
        .catch((error) => {
          self.props.onRequestLoading(false);
          reject(error);
          swal("Opps!", error.message, "error");
        });
    });
  }
  render() {
    let { tabActive } = this.state;

    const { packageDetails = {} } = this.props.currentUser;

    if (this.props.match && this.props.match.params.tab) {
      const urlTab = tabs[this.props.match.params.tab.toUpperCase()];
      if (urlTab !== tabActive) {
        tabActive = urlTab;
      }
    }

    let status = { code: 0, value: "" };
    const { eventData = null } = this.state;
    if (eventData) {
      status = eventData.getStatus();
    }

    if (this.state.isLoading) {
      return (
        <div className="cntEventLoading">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/loading3.gif`}
            alt="loading"
          />
        </div>
      );
    }

    return (
      <EventView
        packageDetails={packageDetails}
        status={status}
        event={this.state.eventData}
        tabs={tabs}
        tabActive={tabActive}
        onChangeTab={this.changeTab}
        {...this}
      />
    );
  }
}

export default compose(withRouter, withFirebase)(Event);
